export default "__VITE_ASSET__BpMwalCP__"